import type { APIClient } from '@src/shared/api';
import { prefetchQuery } from '@src/shared/query';
import { typeGroupsUrl } from './constants';

export default function prefetchActivityTypeGroups(client: APIClient) {
  prefetchQuery(typeGroupsUrl, client, {});
}
